import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ArticleIcon from "@mui/icons-material/Article";
import { getClientArticleByClientArticleID } from "API/swesum";

import ClientArticleCard from "./clientarticlecard/ClientArticleCard";
import { usePayRules } from "Context/PayRules";

const menuItems = [
  {
    text: "Klientartikel",
    icon: <ArticleIcon />,
    divider: false,
    route: "",
  },
];

export default function ClientArticle() {
  const [clientArticle, setClientArticle] = useState(null);
  const { articleID } = useParams();
  const { payRules } = usePayRules();

  useEffect(() => {
    const asyncFetchClientArticle = async () => {
      const clientArticle = await getClientArticleByClientArticleID(articleID);

      setClientArticle(clientArticle);
    };
    asyncFetchClientArticle();
  }, []);

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, p: 3 }}>
          <Typography variant="h5" gutterBottom>
            {`Klientartikel -`} {clientArticle?.Id}
          </Typography>
          {clientArticle ? (
            <ClientArticleCard
              clientArticle={clientArticle}
              payRuleOptions={payRules}
            />
          ) : null}
        </Box>
      </Box>
    </>
  );
}
